import expandEvents, { addNewEvents } from '../../expandEvents.js';

import {
  APPEND_EVENTS,
  SET_CURRENT_DATE,
  GET_EVENT_LIST,
  SET_EVENT_LIST,
  FAILED_EVENT_LIST,
  SET_CURR_EVENT_LIST,
  SET_EVENT_DATE,
  SET_MONTH_SHOWN,
  SET_PARSED_EVENT_LIST_AND_DAYS_OF_EVENTS,
  SET_SHOW_FUTURE_EVENTS,
} from '../actions/';


const initialState = {
  eventList: null,
  expandedEventIds: {},
  parsedEventList: null,
  currEventList: [],
  eventDate: '',
  daysOfEvents: [],
  monthShown: {},
  year: 1920,
  month: 0,
  firstDayOfCurrMonth: null,
  daysInCurrMonth: null,
  prevMonthsDays: null,
  weeksInMonth: null,
  fetching: false,
  error: '',
  showFutureEvents: true,
  pageable: false,
  fetchedMonths: {},
  baseUrl: undefined,
};

export const calendarEvents = ( state = initialState, action ) => {
  switch(action.type) {
    case APPEND_EVENTS:
      return (() => {
        let newEventList = state.eventList ? state.eventList.slice(0) : [];
        let newEvents = [];
        for (let e of action.payload.events) {
          if (state.expandedEventIds[e.id]) {
            continue;
          }
          newEvents.push(e);
        }
        const next = {
          ...state,
          fetching: false,
        };
        next.expandedEventIds = {...state.expandedEventIds};
        for (let e of newEvents) {
          next.expandedEventIds[e.id] = true;
        }
        newEventList = newEventList.concat(expandEvents(newEvents, action.payload.occurrencesByEventId));
        newEventList.sort((a, b) => {
          if (a.end_iso8601 < b.end_iso8601) {
            return -1;
          }
          if (b.end_iso8601 < a.end_iso8601) {
            return 1;
          }
          if (a.id < b.id) {
            return -1;
          }
          if (b.id < a.id) {
            return 1;
          }
          return 0;
        });
        next.eventList = newEventList
        return next;
      })();
    case GET_EVENT_LIST:
      return {
        ...state,
        fetching: true
      };
    case FAILED_EVENT_LIST:
      return {
        ...state,
        error: action.payload,
        fetching: false,
      };
    case SET_CURRENT_DATE:
      return (() => {
        const {currentDate, pageable, baseUrl} = action.payload;
        let lastDate = null;
        for (let event of state.eventList) {
          let eventEnd = new Date(event.end_iso8601);
          if (!lastDate || lastDate < eventEnd) {
            lastDate = eventEnd;
          }
        }
        const next = {
          ...state,
          fetching: false,
          pageable: pageable,
          baseUrl: baseUrl,
        };
        if (location.search.includes('month')) {
          const url = location.href
          let newUrl = new URL(url)
          let date = newUrl.searchParams.get('month')
          const newDate = new Date(date)
          next.year = newDate.getFullYear();
          next.month = newDate.getMonth() + 1;
          next.monthShown = {
            year: next.year,
            month: next.month,
          };
        }
        else if (lastDate && (!currentDate || lastDate < currentDate)) {
          next.year = lastDate.getFullYear();
          next.month = lastDate.getMonth();
          next.monthShown = {
            year: next.year,
            month: next.month,
          };
        } else if (currentDate) {
          next.year = currentDate.getFullYear();
          next.month = currentDate.getMonth();
          next.monthShown = {
            year: next.year,
            month: next.month,
          };
        }
        return next;
      })();
    // case SET_EVENT_LIST:
    //   return (() => {
    //     const {events, currentDate} = action.payload;
    //     let lastDate = null;
    //     for (let event of events) {
    //       let eventEnd = new Date(event.end_iso8601);
    //       if (!lastDate || lastDate < eventEnd) {
    //         lastDate = eventEnd;
    //       }
    //     }
    //     const next = {
    //       ...state,
    //       eventList: events,
    //       fetching: false,
    //     };
    //     if (lastDate && (!currentDate || lastDate < currentDate)) {
    //       next.year = lastDate.getFullYear();
    //       next.month = lastDate.getMonth();
    //       next.monthShown = {
    //         year: next.year,
    //         month: next.month,
    //       };
    //     } else if (currentDate) {
    //       next.year = currentDate.getFullYear();
    //       next.month = currentDate.getMonth();
    //       next.monthShown = {
    //         year: next.year,
    //         month: next.month,
    //       };
    //     }
    //     return next;
    //   })();
    case SET_EVENT_DATE:
      return {
        ...state,
        eventDate: action.payload,
      }
    case SET_PARSED_EVENT_LIST_AND_DAYS_OF_EVENTS:
      return {
        ...state,
        parsedEventList: action.payload,
        daysOfEvents: Object.keys(action.payload),
      }
    case SET_MONTH_SHOWN:
      return {
        ...state,
        monthShown: action.payload,
        year: action.payload.year,
        month: action.payload.month,
      }
    case SET_SHOW_FUTURE_EVENTS:
      return {
        ...state,
        showFutureEvents: false
      }
    default:
      return state;
  }
}